import { useMemo } from 'react';
import { DateUtils } from '@client/core/utils/DateUtils';

export const useFilteredArtists = (artists: any[], filter?: [{ name: string; id: string }]) => {
	const filteredArtists = useMemo(() => {
		let filterIds: string[] | undefined;
		if (filter && filter.length > 0) {
			filterIds = filter.map(f => f.id);
		}

		return artists.filter(artist => {
			if (!artist.location) return false;
			if (filterIds && !filterIds.includes(artist.contentType?.id)) return false;
			return true;
		});
	}, [artists, filter]);

	return filteredArtists;
};

export const useDateRange = (artists: any[]) => {
	const dateRange = useMemo(() => {
		const startDate = DateUtils.getLowestArtistDate(artists);
		const endDate = DateUtils.getHighestArtistDate(artists);
		return DateUtils.getDaysListFromTo(DateUtils.normalizeTime(startDate), DateUtils.normalizeTime(endDate));
	}, [artists]);

	return dateRange;
};

export const useProgram = (artists: any[]) => {
	const program = useMemo(() => {
		const eventsByDay: Record<string, any[]> = {};

		for (const artist of artists) {
			const adjustedStartTime = DateUtils.normalizeTime(new Date(artist.startTime));

			// Adjusting the artist dates, to show the day before if playing past midnight
			adjustedStartTime.setHours(adjustedStartTime.getHours() - 6);

			const day = adjustedStartTime.toISOString().substring(0, 10);

			(eventsByDay[day] ||= []).push(artist);
		}

		const sortedArtists = Object.entries(eventsByDay)
			.sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
			.map(([date, events]) => ({ date, events }));

		return sortedArtists;
	}, [artists]);

	return program;
};
